/**
 * The class diagram's numbers, in diagram units (a box's pixels at zoom 1): the gaps of the
 * automatic layout, packages and folded ones, a box's lines and widths, the blueprint's pins,
 * bundle lanes, and the zoom.
 */

/** Space between two boxes of a row. */
export const COLUMN_GAP = 40;

/** Space between two rows. */
export const ROW_GAP = 64;

/** Room between a package's frame and what is inside. */
export const PACKAGE_PAD = 18;

/** Height of a package's name tab. */
export const PACKAGE_TAB = 22;

/** Height of a folded package's body, below its tab. */
export const FOLDED_BODY = 40;

/** The least width of a folded package. */
export const FOLDED_WIDTH = 150;

/** Room around the text inside a box. */
export const BOX_PAD = 10;

/** Height of the stereotype line. */
export const STEREOTYPE_LINE = 14;

/** Height of the name line. */
export const NAME_LINE = 18;

/** Height of a compartment line. */
export const DETAIL_LINE = 15;

/** The narrowest box. */
export const MIN_BOX_WIDTH = 120;

/** The widest box: longer descriptions wrap. */
export const MAX_BOX_WIDTH = 240;

/** At most this many lines of description; the last one ends with "…" when cut. */
export const MAX_NOTE_LINES = 3;

/** Height of a box's picture. */
export const PICTURE_H = 90;

/** Height of a pin's row. */
export const PIN_LINE = 20;

/** Room a pin's row keeps beside its label for the pin itself. */
export const PIN_ROOM = 16;

/** How far apart bundles lying along the same line are drawn (world units). */
export const BUNDLE_LANE = 30;

/**
 * The width of the direction slices bundles are sorted in to find those lying along each other:
 * a little more than the angle (`asin 0.15`) under which two lines count as along each other.
 */
export const ANGLE_SLICE = 0.16;

/** How far the diagram zooms out and in. */
export const DIAGRAM_ZOOM = { min: 0.05, max: 3, fitMax: 1.4 } as const;

/** How far the "+" (add a pin) sits inside the header's right corner. */
export const PLUS_INSET = 11;

/** How many straight pieces a curve is measured with. */
export const WIRE_STEPS = 24;
